// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("C:\\Users\\rafae\\Downloads\\youfirst-insurance-master\\youfirst-insurance-master\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\rafae\\Downloads\\youfirst-insurance-master\\youfirst-insurance-master\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("C:\\Users\\rafae\\Downloads\\youfirst-insurance-master\\youfirst-insurance-master\\src\\pages\\page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "C:\\Users\\rafae\\Downloads\\youfirst-insurance-master\\youfirst-insurance-master\\.cache\\data.json")

